import * as React from 'react';
import { observer } from 'mobx-react';

import styles from './issue_actions.module.css';
import loglyticsStore from '../../stores/loglytics.store';
import Time from '../../services/time.service';
import Select from '../common/select.component';
import { LoglyticsStatus } from '../../models/loglytics.model';

const IssueActions = observer(() => {
  const issue = loglyticsStore.currentLoglytics;
  if (!issue) return null;
  const status = issue.status ?? LoglyticsStatus.OPEN;

  const statusValues = {
    [LoglyticsStatus.OPEN]: 'Open',
    [LoglyticsStatus.FIXED]: 'Fixed',
    [LoglyticsStatus.IGNORED]: 'Ignored',
  };

  const changeStatus = (value: string) =>
    loglyticsStore.updateIssue(issue.key, { status: value as LoglyticsStatus });

  return (
    <div className={styles.component}>
      {issue.regressedAt &&
        <div className={styles.regressionBadge}>
          Regressed{issue.regressedInVersion ? ` in ${issue.regressedInVersion}` : ''} on {new Time(issue.regressedAt).getLongDate()}
        </div>}
      {status === LoglyticsStatus.FIXED && issue.resolvedOnVersion &&
        <div className={styles.label}>Fixed on version {issue.resolvedOnVersion}</div>}
      <div className={styles.label}>Status:</div>
      <Select
        value={status}
        nameValues={statusValues}
        onChange={changeStatus}/>
    </div>
  );
});

export default IssueActions;
